import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

@Singleton
class UserService extends BaseService {
  async signIn(email, password, origin) {
    return await this.post("/v1/login", { username: email, password, origin });
  }

  async fetch(companyUuid, { filters, order, pagination }) {
    const url = `/v1/companies/${companyUuid}/users`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination
    });
    return await this.get(resourceRoute);
  }

  async fetchWithoutCompanyUuid({ filters }) {
    const url = `/v1/users`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, { filters });
    return await this.get(resourceRoute);
  }

  async fetchByUuid(_companyUuid, uuid) {
    return await this.get(`/v1/users/${uuid}`);
  }

  async getCurrentUser() {
    return await this.post("/v1/login", {});
  }

  async update(_companyUuid, uuid, params) {
    return await super.update(`/v1/users/${uuid}`, params);
  }

  async create(_companyUuid, params) {
    return await this.post(`/v1/users`, params);
  }

  async recoverPassword(email) {
    return await this.destroy(`/v1/users/passwords?email=${email}`);
  }
}

export default UserService;



// WEBPACK FOOTER //
// ./src/core/service/user.service.js